import axios from 'axios'

const state = {
  orders: [],
  freeOrders: [],
  ipns: [],
}

const mutations = {
  setOrders (state, data) {
    state.orders = data
  },
  setIpns (state, data) {
    state.ipns = data
  },
  setFreeOrders (state, data) {
    state.freeOrders = data
  },
}

const actions = {
  getAllOrders ({ commit }) {
    return axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/orders/`)
      .then(({ data }) => {
        commit('setOrders', data)
      })
      .catch(e => console.log(e))
  },
  searchOrders ({ commit }, credentials) {
    return axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/orders/${credentials}`)
      .then(({ data }) => {
        commit('setOrders', data)
      })
      .catch(e => console.log(e))
  },
  searchFreeOrders ({ commit }, credentials) {
    return axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/free-orders/${credentials}`)
      .then(({ data }) => {
        commit('setFreeOrders', data)
      })
      .catch(e => console.log(e))
  },
  getIpns ({ commit }, credentials) {
    return axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/ipns/${credentials}`)
      .then(({ data }) => {
        commit('setIpns', data)
      })
      .catch(e => console.log(e))
  },
  updateOrder ({ commit }, credentials) {
    return axios
      .patch(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/orders/${credentials.id}/`,
        credentials,
      )
      .then(({ data }) => {
        commit('setOrders', data)
      })
  },
  updateOrderItem ({ commit }, credentials) {
    return axios
      .patch(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/order-items/${credentials.id}/`,
        credentials,
      )
      .then(() => console.log(commit))
  },
  orderItemRetry ({ commit }, id) {
    return axios
      .get(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/order-items/${id}/retry-processing/`,
      )
      .catch(({ response }) => alert(JSON.stringify(response.data)))
  },
}

export default {
  state,
  mutations,
  actions,
}
